import React from 'react';
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader';
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar';
import ShopManagementPageHero from '../../components/Shop/Layout/ShopManagementPageHero';
import AllCoupons from "../../components/Shop/AllCoupons";

const ShopAllCoupons = () => {
  return (
    <div className="shop-all-coupons-page-container">
        <DashboardHeader />
        <div className="shop-all-coupons-page-content shop-management-layout">
            <div className="shop-all-coupons-page-sidebar shop-management-sidebar-slot">
              <DashboardSideBar active={16} />
            </div>
            <main className="shop-all-coupons-page-main shop-management-main-panel">
              <ShopManagementPageHero
                eyebrow="Marketing"
                title="Discount Codes"
                copy="Create and manage coupon codes with clean tables and responsive controls."
              />
                <AllCoupons />
            </main>
        </div>
    </div>
  );
};

export default ShopAllCoupons;
